import { cn } from "@/lib/utils";
import { StageBar, type StageBarCounts } from "./StageBar";
const NAME_PX = {
  large: 24,
  compact: 20,
  muted: 14
} as const;
export function FlowSiteCard({
  name,
  summary,
  stages,
  behind,
  variant = "large",
  isMuted = false,
  className
}: {
  name: string;
  summary: string;
  stages: StageBarCounts;
  behind: StageBarCounts;
  variant?: "large" | "compact";
  isMuted?: boolean;
  className?: string;
}) {
  return <div className={cn("flex min-w-0 flex-col", className)} style={isMuted ? {
    gap: 2
  } : {
    gap: 4,
    paddingTop: 14,
    borderTop: "1px solid rgb(var(--ink) / 0.1)"
  }} data-sentry-component="FlowSiteCard" data-sentry-source-file="FlowSiteCard.tsx">
            <span title={name} className={cn("min-w-0 truncate whitespace-nowrap", isMuted ? "text-ink-2" : "text-ink")} style={{
      fontSize: NAME_PX[isMuted ? "muted" : variant],
      letterSpacing: "-0.01em",
      lineHeight: 1.2
    }}>
                {name}
            </span>
            <span className="min-w-0 truncate whitespace-nowrap tabular-nums text-ink-2" style={{
      fontSize: 12.5
    }}>
                {summary}
            </span>
            {!isMuted && <StageBar stages={stages} behind={behind} size="strip" label={summary} className="mt-2" />}
        </div>;
}